/**
 * @description format sites names
 * @param siteName Site name
 */
const sitesNames = (siteName) => {
  siteName = siteName === 'People Finder' ? 'People' : siteName
  return siteName
}

export default {
  sitesNames
}
